export default "__VITE_ASSET__e439325c__"